import React from "react";
const leadsView = () => {
  return <div>LeadsView</div>;
};

export default leadsView;
